var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "212px",
    height: "133px",
    viewBox: "0 0 212 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 192,
    height: 113,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.0%",
    y: "-11.9%",
    width: "117.2%",
    height: "129.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-13--Actions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.8--add-user-button-on-settings-page",
    transform: "translate(-893.000000, -514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solved",
    transform: "translate(751.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Progress-bar",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-37.5797872,39.0797872 C-37.5797872,38.2513601 -36.9040932,37.5797872 -36.0882383,37.5797872 L39.0882383,37.5797872 C39.911998,37.5797872 40.5797872,38.2455845 40.5797872,39.0797872 L40.5797872,39.0797872 C40.5797872,39.9082144 39.9040932,40.5797872 39.0882383,40.5797872 L-36.0882383,40.5797872 C-36.911998,40.5797872 -37.5797872,39.91399 -37.5797872,39.0797872 L-37.5797872,39.0797872 Z",
    id: "Base",
    fill: "#DFE4EE",
    transform: "translate(1.500000, 39.079787) rotate(-90.000000) translate(-1.500000, -39.079787) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.7712766,56.7287234 C-20.7712766,55.9002963 -20.1070503,55.2287234 -19.2637429,55.2287234 L22.2637429,55.2287234 C23.0963308,55.2287234 23.7712766,55.8945206 23.7712766,56.7287234 L23.7712766,56.7287234 C23.7712766,57.5571505 23.1070503,58.2287234 22.2637429,58.2287234 L-19.2637429,58.2287234 C-20.0963308,58.2287234 -20.7712766,57.5629262 -20.7712766,56.7287234 L-20.7712766,56.7287234 Z",
    id: "Fill",
    fill: "#1DDCC0",
    transform: "translate(1.500000, 56.728723) rotate(-90.000000) translate(-1.500000, -56.728723) "
  })), /*#__PURE__*/React.createElement("text", {
    id: 1.216,
    fontFamily: "Helvetica",
    fontSize: 28,
    fontWeight: "normal",
    "line-spacing": 37,
    letterSpacing: -0.2,
    fill: "#1DDCC0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36,
    y: 45
  }, "1.216")), /*#__PURE__*/React.createElement("text", {
    id: "Solved-requests",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 19,
    fill: "#969696"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36,
    y: 77
  }, "Solved requests"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolved);
export default __webpack_public_path__ + "static/media/Solved.ee469dc7a745c4af15e6b10e270f6515.svg";
export { ForwardRef as ReactComponent };